module.exports = __webpack_public_path__ + "3b587c46a452a587bc3c7cfaf3fdfe98.MP3";